import React from "react";
import { FiRefreshCw } from "react-icons/fi";

const ListingFilterHeader = ({
  title,
  page = 0,
  totalPages = 0,
  totalElements = 0,
  resultsLabel,
  showingPageLabel,
  ofLabel,
  refreshLabel,
  loading = false,
  onRefresh,
  actions,
}) => (
  <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
    <div>
      <h2 className="text-base font-semibold text-[#111827]">{title}</h2>
      {showingPageLabel && ofLabel && resultsLabel && (
        <p className="mt-1 text-xs text-[#6b7280]">
          {showingPageLabel} {page + 1} {ofLabel} {Math.max(totalPages, 1)} ·{" "}
          {totalElements.toLocaleString()} {resultsLabel}
        </p>
      )}
    </div>
    <div className="flex items-center gap-3">
      {actions}
      {onRefresh && (
        <button
          type="button"
          onClick={onRefresh}
          disabled={loading}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-[#1d4ed8] transition hover:text-[#1e40af] disabled:opacity-50"
        >
          <FiRefreshCw className={`h-4 w-4 ${loading ? "animate-spin" : ""}`} />
          {refreshLabel}
        </button>
      )}
    </div>
  </div>
);

export default ListingFilterHeader;
